export default __webpack_public_path__ + "static/media/reuse3.d333db10.PNG";